import { useEffect, useContext } from "react"
import {PageTreeContext} from "../../context/pageTreeContext"
import{techIntroPageID} from "../../constants"
import {useNavigate } from 'react-router-dom';


export default function TechIntro(){
    const navigate = useNavigate();
    const pageTreeContextValue = useContext(PageTreeContext);

    useEffect(() => {
        pageTreeContextValue.changeIsBreadcrumbsVisible(false)
        navigate("/lerneinheiten/page/" + techIntroPageID)
    }, [])








    return (
        <div>
            Technische Einführung
        </div>
    )
}